export default "__VITE_ASSET__e560bdcf__"